var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 512,
    viewBox: "0 0 496 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 256C0 119.1 111.1 8 248 8C384.9 8 496 119.1 496 256C496 392.9 384.9 504 248 504C111.1 504 0 392.9 0 256ZM393.7 227.2C398.2 229.8 401.4 231.1 406.6 231.1C418.8 231.1 429.8 221.4 429.8 207.8C429.8 195.9 424.7 189.7 416.9 185.2C361 152.6 284.5 137.4 211.5 137.4C168.6 137.4 129.2 142.3 94 152.6C85 155.2 76.6 162.9 76.6 176.5C76.6 189.8 86.7 200.1 99.9 200.1C103.903 200.1 107.697 198.987 110.935 198.038C111.58 197.849 112.202 197.666 112.8 197.5C195.2 174.5 322.5 184.7 393.7 227.2ZM364.633 303.817C367.791 305.533 371.042 307.3 375.6 307.3C386.5 307.3 394.9 298.6 395 287.8C395 279.1 391.8 272.9 383.7 268.1C334.3 238.7 271.6 222.6 206.7 222.6C165.1 222.6 136.7 228.4 108.9 236.2C98.6 239.1 93.4 246.2 93.4 256.9C93.4 267.6 102.1 276.3 112.8 276.3C116.11 276.3 118.392 275.597 121.277 274.707C122.315 274.388 123.43 274.044 124.7 273.7C207.6 251.2 300.8 266.1 363.3 303.1C363.745 303.335 364.188 303.575 364.633 303.817ZM338 369.3C341.9 371.6 344.5 372.9 348.7 372.9C356.8 372.9 363.9 366.6 363.9 357.5C363.9 348.4 360.3 344.9 354.2 341C282.8 298.3 199.1 296.7 117.2 314.8C109.7 316.4 103.6 321.3 103.6 331.6C103.6 339.7 109.7 347.4 119.4 347.4C121.677 347.4 125.311 346.413 128.655 345.505C129.57 345.257 130.462 345.015 131.3 344.8C203 330.1 275.6 331.7 338 369.3Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyIcon);
export default __webpack_public_path__ + "static/media/Spotify_icon.c8aafaaef43084a7bd1b30415827669a.svg";
export { ForwardRef as ReactComponent };